"use strict";
// helper functions to check properties of the entity goes here
module.exports = {};
